import React from 'react';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import GroupIcon from '@material-ui/icons/Group';
import AutorenewIcon from '@material-ui/icons/Autorenew';

export default [
  {id: 121, name: 'All', alias: 'all', icon: <GroupIcon />},
  {id: 122, name: 'Frequent', alias: 'frequent', icon: <AutorenewIcon />},
  {id: 124, name: 'Starred', alias: 'starred', icon: <StarBorderIcon />},
];
